import type { DynamicFloorEngine } from './dynamic-floor.js';

export type Scenario006Id = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H';

export const SCENARIO_006_META: Record<Scenario006Id, { title: string; desc: string }> = {
  A: { title: 'A · Preparado', desc: 'Mesas 1-10 visibles, flex en reserva' },
  B: { title: 'B · 2 personas', desc: 'Walk-in de pareja' },
  C: { title: 'C · Grupo 6', desc: 'Mesa de seis' },
  D: { title: 'D · Mesa 17 ×30', desc: 'Habilitaci\u00f3n flexible patio' },
  E: { title: 'E · Reorganizar', desc: 'Armar mesa 18 para 12' },
  F: { title: 'F · Cierre', desc: 'Liberar y reordenar' },
  G: { title: 'G · Alta ocupaci\u00f3n', desc: 'Sal\u00f3n cargado' },
  H: { title: 'H · L\u00edmite', desc: 'Intento sin espacio' },
};

export function runScenario006(engine: DynamicFloorEngine, id: Scenario006Id): void {
  engine.reset();
  switch (id) {
    case 'A':
      break;
    case 'B':
      engine.seatWalkIn(2, 'salon');
      break;
    case 'C':
      engine.seatWalkIn(6, 'salon');
      break;
    case 'D':
      engine.configureTable17For30();
      engine.seatAtTable(17, 28);
      break;
    case 'E':
      engine.composeFlexibleTable(18, 12, 'patio');
      engine.seatAtTable(18, 12);
      break;
    case 'F':
      engine.seatAtTable(3, 2);
      engine.closeSession(3);
      break;
    case 'G':
      engine.simulateHighOccupancy();
      break;
    case 'H':
      engine.configureTable17For30();
      engine.seatAtTable(17, 30);
      engine.composeFlexibleTable(18, 24, 'patio');
      engine.composeFlexibleTable(19, 24, 'patio');
      engine.composeFlexibleTable(20, 24, 'patio');
      break;
    default:
      break;
  }
}
